import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-[#01162D] text-white border-t-4 border-[#1F6FD6]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12 mb-10 md:mb-12">
          <div>
            <div className="inline-block bg-white rounded-md px-4 py-3 mb-6">
              <img src="/logo-sma-concept.png" alt="SMA CONCEPT" className="h-16 w-auto" />
            </div>
            <p className="text-[#9FB3CC] text-sm leading-relaxed">
              Expert en menuiserie aluminium, PVC, bois et serrurerie depuis 2015. Entreprise certifiée RGE à Saint-Étienne.
            </p>
            <p className="mt-5 text-xs font-bold uppercase tracking-[0.2em] text-[#3B8BEF]">
              Des solutions sur mesure, conçues pour durer
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-6 text-white uppercase tracking-[0.2em] border-l-2 border-[#1F6FD6] pl-3">Nos Services</h4>
            <ul className="space-y-3">
              {['Menuiserie Aluminium', 'Serrurerie', 'Menuiserie PVC', 'Menuiserie Bois'].map((s) => (
                <li key={s} className="text-[#9FB3CC] hover:text-[#3B8BEF] transition-colors cursor-default text-sm">{s}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-6 text-white uppercase tracking-[0.2em] border-l-2 border-[#1F6FD6] pl-3">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:0620604166" className="flex items-start gap-3 text-[#9FB3CC] hover:text-[#3B8BEF] transition-colors text-sm" data-testid="footer-phone">
                  <Phone size={18} className="flex-shrink-0 mt-0.5 text-[#3B8BEF]" />
                  <span className="font-medium">06 20 60 41 66</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@sma-concept.fr" className="flex items-start gap-3 text-[#9FB3CC] hover:text-[#3B8BEF] transition-colors text-sm" data-testid="footer-email">
                  <Mail size={18} className="flex-shrink-0 mt-0.5 text-[#3B8BEF]" />
                  <span>contact@sma-concept.fr</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#9FB3CC] text-sm">
                <MapPin size={18} className="flex-shrink-0 mt-0.5 text-[#3B8BEF]" />
                <span>2 Rue Sainte Catherine<br />42000 Saint-Étienne</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-6 text-white uppercase tracking-[0.2em] border-l-2 border-[#1F6FD6] pl-3">Horaires</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <Clock size={18} className="text-[#3B8BEF] flex-shrink-0 mt-0.5" />
                <div className="text-[#9FB3CC]">
                  <p className="font-semibold text-white mb-1">Lundi - Jeudi</p>
                  <p>8h-12h / 14h-18h</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock size={18} className="text-[#3B8BEF] flex-shrink-0 mt-0.5" />
                <div className="text-[#9FB3CC]">
                  <p className="font-semibold text-white mb-1">Vendredi</p>
                  <p>8h-12h</p>
                </div>
              </div>
              <p className="text-[#9FB3CC] text-xs italic mt-4">Samedi - Dimanche : Fermé</p>
            </div>

            <div className="mt-6">
              <p className="text-xs text-[#9FB3CC] mb-1">Assurance April</p>
              <p className="text-xs text-[#3B8BEF] font-mono">N° 26036672144</p>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1F6FD6]/30 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#9FB3CC] text-sm">
            © {new Date().getFullYear()} SMA CONCEPT. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/mentions-legales" onClick={scrollToTop} className="text-[#9FB3CC] hover:text-[#3B8BEF] transition-colors" data-testid="footer-legal-link">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" onClick={scrollToTop} className="text-[#9FB3CC] hover:text-[#3B8BEF] transition-colors" data-testid="footer-privacy-link">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
